import { render, staticRenderFns } from "./CommentStep.vue?vue&type=template&id=64870b4d"
import script from "./CommentStep.vue?vue&type=script&lang=js"
export * from "./CommentStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports